import customer1Image from './assets/customer1.jpg';
import customer2Image from './assets/customer2.jpg';
import customer3Image from './assets/customer3.jpg';
import customer4Image from './assets/customer4.jpg';
import './Testimonials.css';
import TestimonialCard from './TestimonialCard';

const customers = [
  {
    fullName: 'Anamika Mehta',
    image: customer1Image,
    rating: [1, 1, 1, 1, 0.5],
    says: `Fresh flavors and friendly service. The mezze platter is a must!`,
  },
  {
    fullName: 'Ishan Sharma',
    image: customer2Image,
    rating: [1, 1, 1, 1, 1],
    says: `Loved the citrusy twist on classics. Will be back with friends!`,
  },
  {
    fullName: 'Amara Sade',
    image: customer3Image,
    rating: [1, 1, 1, 1, 0.5],
    says: `Cozy ambience and fantastic mains. The grilled fish was perfect.`,
  },
  {
    fullName: 'Sukchan Barma',
    image: customer4Image,
    rating: [1, 1, 1, 1],
    says: `Bright, zesty desserts! The citrus tart is my new favorite.`,
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials">
      <div className="container grid">
        <h2>What people say about us!</h2>
        {customers.map((customer, index) => 
          <TestimonialCard key={index} customer={customer} />
        )}
     </div>
    </section>
  );
};

export default Testimonials;
